import {each, deepClone} from '@/utils/assist'
//@param data门店优惠的数据 pres选中的优惠 discountProducts优惠打折的餐品 manualPreferentials手动打折的列表 cardNum卡号 list对应的优惠项 preDeliveryPrice配送优惠的
export const state = () => ({
  data: [],
  pres: {},
  list: [],
  cloneData: [],
  discountProducts: {},
  manualPreferentials: [],
  cardNum: null,
  cardMsg: null,
  total: 0,
  preDeliveryPrice: 0,
  orderData: {},
});
export const mutations = {
  updateData(state, o) {
    each(o, (value, key) => {
      state[key] = value
    })
  },
  updateOrder(state, o) {
    each(o, (value, key) => {
      state.orderData[key] = value
    })
  },
};
export const actions = {
  init({commit, dispatch, state}, {proPres = [], pres = []}) {
    // o记录优惠活动对应的位置
    if (!proPres.length && !pres.length) return;
    let data = [].concat(proPres, pres),
      o = {},
      cloneData;
    each(data, (value, index) => {
      let i = 0,
        pid = value.pid,
        key = [pid],
        memory = [index];
      value.isSelect = false;
      value.isAccord = false;
      o[pid] = index;
      each(value.items, (value, index) => {
        if (value.canPre) i++;
        value.parent_kye = pid;
        value.isSelect = false;
        key.push(value.index);
        memory.push(index);
        o[key.join('-')] = memory.join('-');
        key.pop();
        memory.pop()
      });
      value.canSelectNum = i
    });
    cloneData = deepClone(data);
    console.log(data,'jjj')
    commit('updateData', {data, cloneData});
    return o
  },
  clear({commit, dispatch, state}, {aftPrePrice}) {
    let cloneData = state.cloneData,
      data = [],
      pres = {},
      list = [],
      discountProducts = [];
    each(deepClone(cloneData), (value) => data.push(value));
    commit('updateData', {data, pres, list, discountProducts, total: 0, preDeliveryPrice: 0, manualPreferentials: []});
    this.dispatch('booking/cart/updateFee', {aftPrePrice, couponOffsetMoney: 0});
    this.dispatch('booking/order/update', {aftPrePrice, couponOffsetMoney: 0});
  },
  update({commit, dispatch, state}, {list, data, pres, aftPrePrice, discountProducts, preDeliveryPrice}) {
    this.commit('booking/preferential/updateData', {list, data, pres, discountProducts, preDeliveryPrice});
    this.dispatch('booking/cart/updateFee', {aftPrePrice, couponOffsetMoney: 0});
    this.dispatch('booking/order/update', {aftPrePrice, couponOffsetMoney: 0});
  }
};



// WEBPACK FOOTER //
// ./store/booking/preferential.js